import DOMReady from '../utils/DOMReady';
import youtube from '../modules/youtube';
import '../../css/blocks/video-hero.scss';
DOMReady(function () {
    youtube.init();
});
